var _react_refresh_temp_1;
var _react_refresh_temp_2, _react_refresh_temp_3;
_react_refresh_temp_2 = $RefreshSig$();
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { ARROW_DOWN_KEY, ARROW_UP_KEY } from '#constants';
import { findNextFocusItemRef } from './ArrowNavigationMenu.services';
import styles from '../../Menu.module.css';
export const useMenuItem = ({ disabled, hidden, menuItemRef, }) => {
    _react_refresh_temp_2();
    const { focusedItemRef, registerMenuItem } = useContext(FocusNavigationContext);
    useEffect(() => {
        registerMenuItem(menuItemRef, hidden, disabled);
    }, [disabled, hidden, menuItemRef, registerMenuItem]);
    useEffect(() => {
        if (menuItemRef === focusedItemRef) {
            menuItemRef.current?.focus();
        }
    }, [focusedItemRef, menuItemRef]);
    return { focusedItemRef };
};
_react_refresh_temp_2(useMenuItem, "gXsAzZ6lCeaOVPVClGuGCQjXW+w=");
const FocusNavigationContext = createContext({
    focusedItemRef: null,
    registerMenuItem: () => { },
});
export const ArrowNavigationMenu = ({ children }) => {
    _react_refresh_temp_3();
    const [focusedItemRef, setFocusedItemRef] = useState(null);
    const [registeredMenuItems, setRegisteredMenuItems] = useState([]);
    const focusableItems = useMemo(() => {
        return registeredMenuItems.filter((i) => !i.disabled && !i.hidden);
    }, [registeredMenuItems]);
    useEffect(() => {
        if (focusableItems.length === 0) {
            return;
        }
        setFocusedItemRef(focusableItems[0].itemRef);
    }, [focusableItems]);
    const changeFocus = useCallback((e) => {
        const key = e.key;
        if (key === ARROW_UP_KEY || key === ARROW_DOWN_KEY) {
            e.stopPropagation();
            setFocusedItemRef((focusedItemRef) => {
                return findNextFocusItemRef({
                    focusableItems,
                    focusedItemRef,
                    action: key,
                });
            });
        }
    }, [focusableItems]);
    const registerMenuItem = useCallback((itemRef, hidden, disabled) => {
        setRegisteredMenuItems((registeredMenuItems) => {
            const indexInCurrentList = registeredMenuItems
                .map((i) => i.itemRef)
                .indexOf(itemRef);
            if (indexInCurrentList >= 0) {
                const newRegisteredItems = [...registeredMenuItems];
                newRegisteredItems[indexInCurrentList] = {
                    itemRef: itemRef,
                    hidden,
                    disabled,
                };
                return newRegisteredItems;
            }
            return [
                ...registeredMenuItems,
                {
                    itemRef: itemRef,
                    hidden,
                    disabled,
                    index: registeredMenuItems.length,
                },
            ];
        });
    }, []);
    const providerValue = useMemo(() => ({
        focusedItemRef: focusedItemRef,
        registerMenuItem,
    }), [focusedItemRef, registerMenuItem]);
    return (_jsx("ul", { className: styles.Container, onKeyDown: changeFocus, role: "menu", children: _jsx(FocusNavigationContext.Provider, { value: providerValue, children: children }) }));
};
_react_refresh_temp_1 = ArrowNavigationMenu;
$RefreshReg$(_react_refresh_temp_1, "ArrowNavigationMenu");
_react_refresh_temp_3(ArrowNavigationMenu, "kdHnU53W8UeFBIYgofLATTXnUVY=");
